import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

const fallbackProjects = [
    { image: require('./../../images/projects/portrait/pic1.jpg'), title: 'Referans 1' },
    { image: require('./../../images/projects/portrait/pic2.jpg'), title: 'Referans 2' },
    { image: require('./../../images/projects/portrait/pic3.jpg'), title: 'Referans 3' },
    { image: require('./../../images/projects/portrait/pic4.jpg'), title: 'Referans 4' },
    { image: require('./../../images/projects/portrait/pic5.jpg'), title: 'Referans 5' },
    { image: require('./../../images/projects/portrait/pic6.jpg'), title: 'Referans 6' },
    { image: require('./../../images/projects/portrait/pic7.jpg'), title: 'Referans 7' }
];

var bgimg1 = require('./../../images/background/cross-line2.png');

class Projects1 extends React.Component {
    static contextType = SiteContentContext;

    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }

        loadScript('./assets/js/custom.js');
    }

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const section = t?.pages?.home?.projects || {};
        const config = getByPath(content, 'home.projects', {});

        const projectTexts = Array.isArray(section.items) ? section.items : [];
        const projectConfigs = Array.isArray(config.items) ? config.items : [];
        const hasConfiguredProjects = projectConfigs.length > 0;
        const projects = (hasConfiguredProjects ? projectConfigs : fallbackProjects).map((item, index) => {
            const fallback = fallbackProjects[index % fallbackProjects.length];
            const textItem = projectTexts[index] || {};
            const imageUrl = item?.imageUrl || item?.image || '';

            return {
                image: resolveMediaSrc(imageUrl, fallback.image),
                title: textItem.title || item?.title || fallback.title,
            };
        });

        const options = {
            loop: projects.length > 1,
            autoplay: projects.length > 1,
            autoplayTimeout: 2600,
            autoplayHoverPause: true,
            margin: 30,
            nav: true,
            dots: false,
            navText: ['Geri', 'İleri'],
            responsive: {
                0: { items: 1 },
                540: { items: 2 },
                768: { items: 3 },
                991: { items: 3 },
                1136: { items: 4 },
                1366: { items: 5 }
            }
        };

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b50 bg-white">
                    <div className="section-content">
                        <div className="container">
                            <div className="section-head">
                                <div className="sx-separator-outer separator-center">
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        <h3 className="sep-line-one">{section.title || 'Referanslarimiz'}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filter-carousal-1-outer relative z-index1">
                            <div className="filter-carousal-1 container-fluid p-b30">
                                <div className="section-content ">
                                    <OwlCarousel className="owl-carousel owl-carousel-filter owl-btn-bottom-center mfp-gallery navigation-with-name" {...options}>
                                        {projects.map((item, index) => (
                                            <div key={index} className="item fadingcol overflow-hide">
                                                <div className="sx-box image-hover-block">
                                                    <div className="sx-thum-bx">
                                                        <img src={item.image} alt={item.title || `Referans logosu ${index + 1}`} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </OwlCarousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Projects1;
